import { render, staticRenderFns } from "./ExternalEmvTap.vue?vue&type=template&id=0d0e10f9&"
import script from "./ExternalEmvTap.vue?vue&type=script&lang=js&"
export * from "./ExternalEmvTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports